// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__w7uV8","container":"auth_container__KdvHV"};